import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderUser = {
  showBackButton: boolean;
  isDesktopIframe: boolean;
  companionStatus: React.ReactNode | null;
  callButtonNode: React.ReactNode | null;
  chatMenuNode: React.ReactNode | null;
  chatStarredNode: React.ReactNode | null;
  companionTitle: React.ReactNode | null;
  handleClickBack: () => void;
};

export const ChatHeaderUser: React.FC<TChatHeaderUser> = ({
  showBackButton,
  isDesktopIframe,
  companionStatus,
  callButtonNode,
  chatMenuNode,
  chatStarredNode,
  handleClickBack,
  companionTitle,
}) => {
  return (
    <div
      className={classNames(styles['container'], isDesktopIframe && styles['container_iframe_desktop'])}
      data-testid="chat_header_user"
    >
      {showBackButton && (
        <button className={styles['back_button']} onClick={handleClickBack} data-testid="back_button">
          <IconActionChevronLeft16 color="icon-main-default" />
        </button>
      )}
      <div className={styles['companion']} data-testid="chat_header_companion">
        {companionTitle}
        <div>{companionStatus}</div>
      </div>
      <div className={styles['action_buttons']}>
        {callButtonNode}
        {chatStarredNode}
        {chatMenuNode}
      </div>
    </div>
  );
};
